// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.simx-release-tag-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
}

.simx-release-tag-list-item {
  margin: 4px 8px 4px 0;
}

.simx-release-tag-list--add-block {
  position: relative;
}

.simx-release-tag-list--add-menu {
  background: rgb(230, 235, 235);
  border: solid 1px rgb(194.5833333333, 206.6666666667, 206.6666666667);
  border-radius: 4px;
  padding: 5px;
  position: absolute;
  top: calc(100% + 2px);
  right: -8px;
  z-index: 100;
}

.simx-release-tag-list--add-menu--no-items-message {
  text-align: center;
  width: 100px;
}

.simx-release-tag-list--add-menu-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.simx-release-tag-list--add-menu-list-item {
  border-radius: 4px;
  cursor: pointer;
  padding: 5px;
  transition: background 0.2s;
}

.simx-release-tag-list--add-action {
  appearance: none;
  background: none;
  border: none;
  margin: 0;
  padding: 0;
  background: rgb(255, 255, 255);
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  padding: 4px;
  width: 25px;
  height: 25px;
  transition: background 0.2s;
}
.simx-release-tag-list--add-action svg {
  width: 100%;
  height: 100%;
}
.simx-release-tag-list--add-action svg path {
  fill: rgb(123.75, 150, 150);
  transition: fill 0.2s;
}
.simx-release-tag-list--add-action:hover:not(:active):not(.simx-active) {
  background: rgb(159.1666666667, 178.3333333333, 178.3333333333);
}
.simx-release-tag-list--add-action:hover:not(:active):not(.simx-active) svg path {
  fill: rgb(255, 255, 255);
}
.simx-release-tag-list--add-action:active, .simx-release-tag-list--add-action.simx-active {
  background: rgb(123.75, 150, 150);
}
.simx-release-tag-list--add-action:active svg path, .simx-release-tag-list--add-action.simx-active svg path {
  fill: rgb(255, 255, 255);
}`, "",{"version":3,"sources":["webpack://./src/app/modules/ui-elements/components/controls/release-tag-list/release-tag-list.component.scss","webpack://./src/assets/styles/_colors.scss","webpack://./src/assets/styles/_theme.scss"],"names":[],"mappings":"AAGA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,eAAA;AAHF;;AAMA;EACE,qBAAA;AAHF;;AAMA;EACE,kBAAA;AAHF;;AAMA;EACE,8BCV8B;EDW9B,qEAAA;EACA,kBEvB4B;EFwB5B,YAAA;EACA,kBAAA;EACE,qBAAA;EACA,WAAA;EACF,YAAA;AAHF;;AAMA;EACE,kBAAA;EACA,YAAA;AAHF;;AAMA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;AAHF;;AAMA;EACE,kBE3C4B;EF4C5B,eAAA;EACA,YAAA;EACA,2BAAA;AAHF;;AAMA;EACE,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EAEA,8BCxC8B;EDyC9B,kBEzD4B;EF0D5B,eAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;AAJF;AAME;EACE,WAAA;EACA,YAAA;AAJJ;AAMI;EACE,2BCvD0B;EDwD1B,qBAAA;AAJN;AAQE;EACE,+DC9D4B;ADwDhC;AASM;EACE,wBChEwB;ADyDhC;AAYE;EAEE,iCCxE4B;AD6DhC;AAcM;EACE,wBC3EwB;AD+DhC","sourcesContent":["@use 'colors';\n@use 'theme';\n\n.simx-release-tag-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.simx-release-tag-list-item {\n  margin: 4px 8px 4px 0;\n}\n\n.simx-release-tag-list--add-block {\n  position: relative;\n}\n\n.simx-release-tag-list--add-menu {\n  background: colors.$simxColorLightNeutral;\n  border: solid 1px colors.$simxColorLightNeutralDark;\n  border-radius: theme.$simxBorderRadiusDefault;\n  padding: 5px;\n  position: absolute;\n    top: calc(100% + 2px);\n    right: -8px;\n  z-index: 100;\n}\n\n.simx-release-tag-list--add-menu--no-items-message {\n  text-align: center;\n  width: 100px;\n}\n\n.simx-release-tag-list--add-menu-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.simx-release-tag-list--add-menu-list-item {\n  border-radius: theme.$simxBorderRadiusDefault;\n  cursor: pointer;\n  padding: 5px;\n  transition: background theme.$simxTransitionSpeedDefault;\n}\n\n.simx-release-tag-list--add-action {\n  appearance: none;\n  background: none;\n  border: none;\n  margin: 0;\n  padding: 0;\n\n  background: colors.$simxColorWhite;\n  border-radius: theme.$simxBorderRadiusDefault;\n  cursor: pointer;\n  display: flex;\n  padding: 4px;\n  width: 25px;\n  height: 25px;\n  transition: background theme.$simxTransitionSpeedDefault;\n\n  svg {\n    width: 100%;\n    height: 100%;\n\n    path {\n      fill: colors.$simxColorLightNeutralDarkest;\n      transition: fill theme.$simxTransitionSpeedDefault;\n    }\n  }\n\n  &:hover:not(:active):not(.simx-active) {\n    background: colors.$simxColorLightNeutralDarker;\n\n    svg {\n      path {\n        fill: colors.$simxColorWhite;\n      }\n    }\n  }\n\n  &:active,\n  &.simx-active {\n    background: colors.$simxColorLightNeutralDarkest;\n\n    svg {\n      path {\n        fill: colors.$simxColorWhite;\n      }\n    }\n  }\n}\n","@use 'sass:color';\n\n$simxColorBrightAccent:         rgb(229, 0, 44);  // Red\n$simxColorDarkAccent:           rgb(54, 47, 65);  // Purple\n$simxColorBrightGreen:          rgb(0, 201, 133);\n$simxColorMustard:              rgb(255, 177, 0);\n\n$simxColorDarkAccentMedium:     color.adjust($simxColorDarkAccent, $lightness: 6%);\n$simxColorDarkAccentLight:      color.adjust($simxColorDarkAccent, $lightness: 53%);\n$simxColorDarkNeutral:          rgb(21, 19, 25);\n$simxColorDarkNeutralLight:     color.adjust(color.adjust($simxColorDarkNeutral, $saturation: -7%), $lightness: 76%);\n$simxColorLightNeutral:         rgb(230, 235, 235);\n$simxColorLightNeutralLight:    color.adjust($simxColorLightNeutral, $lightness: 5%);\n$simxColorLightNeutralDark:     color.adjust($simxColorLightNeutral, $lightness: -12.5%);\n$simxColorLightNeutralDarker:   color.adjust($simxColorLightNeutral, $lightness: -25%);\n$simxColorLightNeutralDarkest:  color.adjust($simxColorLightNeutral, $lightness: -37.5%);\n$simxColorWhite:                rgb(255, 255, 255);\n\n$simxColorTextDefault:          $simxColorDarkNeutral;\n$simxColorTextLight:            rgb(166, 167, 169);\n$simxColorTextInvert:           rgba(255, 255, 255, 0.95);\n$simxColorTextOverDarkAccent:   rgba($simxColorWhite, 0.95);\n\n$simxColorControlBackground:    $simxColorWhite;\n$simxColorControlBorder:        $simxColorLightNeutralDark;\n","$simxBorderRadiusDefault:     4px;\n$simxBorderRadiusHeavy:       calc($simxBorderRadiusDefault * 2);\n\n$simxTransitionSpeedDefault:  0.2s;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
